import { axiosEduServer } from "../utils/configAxios";

export const crearDocenteIdioma = (data) => {
  return axiosEduServer.post('/docenteidioma', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarDocenteIdioma = (id, data) => {
  return axiosEduServer.put(`/docenteidioma/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarDocenteIdioma = (id) => {
  return axiosEduServer.delete(`/docenteidioma/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllDocenteIdiomas = () => {
  return axiosEduServer.get('/docenteidioma').then(({ data }) => data).catch((err) => { throw err });
};

export const getAllDocenteIdiomasByIdDocente = (idDocente) => {
  return axiosEduServer.get(`/docenteidioma/iddocente/${idDocente}`).then(({ data }) => data).catch((err) => { throw err });
};